var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-container"},[_c('LivePolling',{attrs:{"detail":{
    slug: _vm.$route.params.slug,
    polling: 1
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }